<template>
  <TsRow
  v-if="steps && steps.length > 0"
    :appendClass="twMerge('lg:flex lg:justify-center max-md:px-0 max-md:flex max-md:flex-col  mb-10', props.rootClass)">
    <template v-for="(step, index) in steps" :key="step.id">
      <TsColumn
        :appendClass="`${steps.length - 1 !== index ? `max-md:before:h-[8px] lg:max-w-max after:content-[''] max-md:after:border-l-2 after:border-[#128AE5] before:content-['']  after:ml-14 after:p-9 p-0 px-2` : 'max-w-max'}`">
        <div
          :class="`${steps.length - 1 !== index ? `relative flex items-center before:content-[''] before:border-t-2 before:border-r-2 before:w-[10px] before:h-[10px] before:border-[#128AE5] before:absolute max-md:before:left-[3.25rem] max-md:before:top-36 before:right-0 max-md:before:rotate-[135deg] before:rotate-45  after:content-[''] lg:after:border-b-2 after:border-[#128AE5] lg:after:min-w-36` : `flex items-center`}`">
          <div
            class="border lg:p-2 max-md:border-2 max-md:border-[#C7E4FF] lg:border-[#128AE5] lg:border-dashed rounded-xl">
            <TsCardSteps :heading="`Step ${index + 1}`" :footerText="!isMobile ? `${step.text}` : ''"
              :appendClass="`${index === 0 ? 'bg-[#128AE5]' : 'bg-[#056BC4]'}  shadow-none  py-4 px-3`"
              :icon="step.icon" />
          </div>
          <div v-if="isMobile" class="ml-2">
            <TsTypography weight="semibold" variant="h4" appendClass="text-idle-black">{{ step.text }}
            </TsTypography>
          </div>
        </div>
      </TsColumn>
    </template>
  </TsRow>
</template>



<script setup lang="ts">

import {twMerge} from "tailwind-merge";

const TsCardSteps = defineAsyncComponent(
    () => import('~/components/organisms/TsCardSteps.vue')
);

const {isMobile}=useDevice();

type Step = {
  id: number;
  icon: string;
  text: string;
};

type Props = {
  rootClass?: string;
  steps: Step[];
}

const props = withDefaults(defineProps<Props>(), {
  steps: (() => [
    {
      id: 1,
      icon: 'lucide:mail',
      text: 'Meld u aan met uw e-mailadres om deals te ontgrendelen',
    },
    {
      id: 2,
      icon: 'mdi:tag-multiple-outline',
      text: 'Blader en kies uit exclusieve kortingen',
    },
    {
      id: 3,
      icon: 'ph:gift',
      text: 'Wissel uw geselecteerde aanbieding in bij het afrekenen.',
    },
  ]),
});
</script>